import * as tslib_1 from "tslib";
import AttachmentMenuEntrySource from '../types/AttachmentMenuEntrySource';
import createAttachmentHandler from '../utils/createAttachmentHandler';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Image } from 'office-ui-fabric-react/lib/Image';
import { attachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import clickAttachButton from 'owa-mail-compose-store/lib/actions/clickAttachButton';
import trySaveMessage from 'owa-mail-compose-store/lib/actions/trySaveMessage';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import strings from 'owa-strings/owa-mail-strings';
import { logUserAction } from 'owa-surface-actions';
import * as React from 'react';
import { resolve as urlResolve } from 'url';
import { ContextualMenu, ContextualMenuItemType, } from 'office-ui-fabric-react/lib/ContextualMenu';
import { AttachmentLocalComputerFilePicker, FilePickerAction, FileSelectionFilter, } from 'owa-attachment-filepicker-view';
var styles = require('./ComposeBottom.scss');
var attachStyles = require('./AttachToolbarButton.scss');
var classNames = require('classnames/bind').bind(styles);
var DROPDOWN_SVG = require('./svg/dropdown.svg');
export function getAttachmentCommandItems(getAttachmentLocalComputerFilePicker, inlineImagePlugin, viewState) {
    var openFilePicker = function () {
        if (!viewState.itemId) {
            trySaveMessage(viewState);
        }
        getAttachmentLocalComputerFilePicker()
            .getInnerComponent()
            .click();
    };
    return [
        {
            key: 'attachFromHeader',
            name: strings.attachFromMenuHeaderText,
            itemType: ContextualMenuItemType.Header,
        },
        {
            key: 'addMyComputerAttachment',
            name: attachmentMultiMenuEntry.computer.text(),
            iconProps: attachmentMultiMenuEntry.computer.iconProps,
            onClick: function (event, item) {
                if (isControlFeatureEnabled('rp-customSurfaceActions')) {
                    logUserAction(true /* isCompose */, 'computerAttach', item);
                }
                attachmentMultiMenuEntry.computer.logUsage(AttachmentMenuEntrySource.ToolBar);
                openFilePicker();
            },
        },
        {
            key: 'addOnlineLocationAttachment',
            name: attachmentMultiMenuEntry.onlineLocation.text(),
            iconProps: attachmentMultiMenuEntry.onlineLocation.iconProps,
            onClick: function (event, item) {
                if (isControlFeatureEnabled('rp-customSurfaceActions')) {
                    logUserAction(true /* isCompose */, 'onlineAttach', item);
                }
                attachmentMultiMenuEntry.onlineLocation.logUsage(AttachmentMenuEntrySource.ToolBar);
                clickAttachButton(false /*isInline*/, function (files, shouldShare, isInline) {
                    return createAttachmentHandler(files, inlineImagePlugin, viewState, shouldShare, isInline);
                }, viewState);
            },
        },
    ];
}
var AttachToolbarButton = /** @class */ (function (_super) {
    tslib_1.__extends(AttachToolbarButton, _super);
    function AttachToolbarButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggleAttachmentMenu = function (event) {
            _this.setState({
                isAttachmentMenuShown: !_this.state.isAttachmentMenuShown,
            });
        };
        _this.state = {
            isAttachmentMenuShown: false,
        };
        return _this;
    }
    Object.defineProperty(AttachToolbarButton.prototype, "commandItems", {
        get: function () {
            var _this = this;
            return getAttachmentCommandItems(function () { return _this.attachmentLocalComputerFilePicker; }, this.props.inlineImagePlugin, this.props.viewState);
        },
        enumerable: true,
        configurable: true
    });
    AttachToolbarButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, viewState = _a.viewState, className = _a.className, _b = _a.menuItem, key = _b.key, name = _b.name, imageUrl = _b.imageUrl;
        var handler = attachmentMultiMenuEntry.computer.getCreateAttachmentHandler(viewState.attachmentWell, function (files, shouldShare, isInline) {
            return createAttachmentHandler(files, _this.props.inlineImagePlugin, _this.props.viewState, shouldShare, isInline);
        });
        return (React.createElement("span", { className: classNames(styles.affordanceMenuButtonSpan, attachStyles.attachButton), ref: function (ref) { return (_this.attachButton = ref); } },
            React.createElement(AttachmentLocalComputerFilePicker, { ref: function (ref) { return (_this.attachmentLocalComputerFilePicker = ref); }, fileSelectionFilter: FileSelectionFilter.None, action: FilePickerAction.Attach, createAttachmentHandler: handler }),
            React.createElement(IconButton, { key: key, onClick: this.onToggleAttachmentMenu, title: name, className: classNames(className, {
                    checked: this.state.isAttachmentMenuShown,
                }, attachStyles.attachToolbarButton) },
                React.createElement(Image, { className: classNames(styles.image, attachStyles.attachImage), shouldFadeIn: false, src: urlResolve(getPackageBaseUrl(), imageUrl) }),
                React.createElement(Image, { className: classNames(styles.image, attachStyles.chevronImage), shouldFadeIn: false, src: urlResolve(getPackageBaseUrl(), DROPDOWN_SVG) })),
            this.state.isAttachmentMenuShown && (React.createElement(ContextualMenu, { items: this.commandItems, target: this.attachButton, directionalHint: 4 /* bottomLeftEdge */, onDismiss: this.onToggleAttachmentMenu }))));
    };
    tslib_1.__decorate([
        computed
    ], AttachToolbarButton.prototype, "commandItems", null);
    AttachToolbarButton = tslib_1.__decorate([
        observer
    ], AttachToolbarButton);
    return AttachToolbarButton;
}(React.Component));
export default AttachToolbarButton;
//# sourceMappingURL=AttachToolbarButton.js.map